"use client"

import { useEffect, useCallback } from "react"
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command"

import {
  DialogTitle,
} from "@/components/ui/dialog"
import { useRouter } from "next/navigation"
import { useAuth } from "@/context/AuthContext"
import { useTheme } from "next-themes"

interface MenuCommandProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function CommandMenu({ open, setOpen }: MenuCommandProps) {

  const router = useRouter()

  const { user, signOut } = useAuth()
  const { theme, setTheme } = useTheme()

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen(!open); // Uses the prop function
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [open, setOpen]);

  const runCommand = useCallback((command: () => void) => {
    command()
    setOpen(false)
  }, [setOpen])

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <DialogTitle></DialogTitle>
      <CommandInput placeholder="Search for an action..." />
      <CommandList>

        <CommandEmpty>No actions found</CommandEmpty>

        <CommandGroup heading="Research">
          <CommandItem onSelect={() => runCommand(() => router.push("/find"))}>
            Find a case
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/search"))}>
            Search for cases
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/ask"))}>
            Ask a question
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/bookmarks?panel=searches"))}>
            See bookmarked searches
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/bookmarks?panel=documents"))}>
            See bookmarked documents
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/bookmarks?panel=paragraphs"))}>
            See bookmarked paragraphs
          </CommandItem>
        </CommandGroup>

        <CommandSeparator />

        <CommandGroup heading="Settings">
          <CommandItem onSelect={() => runCommand(() => router.push("/preferences"))}>
            Change preferences
          </CommandItem>
    
          {theme === "dark" && (
            <CommandItem onSelect={() => runCommand(() => setTheme("light"))}>
              Switch to light mode
            </CommandItem>
          )}
          {theme === "light" && (
            <CommandItem onSelect={() => runCommand(() => setTheme("dark"))}>
              Switch to dark mode
            </CommandItem>
          )}
        </CommandGroup>

        <CommandSeparator />

        <CommandGroup heading="User">
          {!user && (
            <CommandItem onSelect={() => runCommand(() => router.push("/sign-in"))}>
              Sign in
            </CommandItem>
          )}
          {
          user && (
            <CommandItem onSelect={() => runCommand(() => signOut())}>
              Sign out
            </CommandItem>
          )}
          <CommandItem onSelect={() => runCommand(() => router.push("/preferences"))}>
            Change name
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/preferences"))}>
            Change email
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/preferences"))}>
            Change password
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/preferences"))}>
            Manage subscription
          </CommandItem>
        </CommandGroup>

        {/* <CommandSeparator /> */}

        {/* <CommandGroup heading="Tools">
          <CommandItem onSelect={() => runCommand(() => router.push("/api"))}>
            Learn about our API
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/python-package"))}>
            Learn about our Python package
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => router.push("/r-package"))}>
            Learn about our R package
          </CommandItem>
        </CommandGroup> */}
      </CommandList>
    </CommandDialog>
  )
}
